var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"mx-4 mt-6 md:mt-8"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }